import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateDataFreshnessPolicyParams {
  workbookId: string;
  deletePolicy: boolean;
  intervalInMinutes: number;
  cachingPolicyType: string;
  daysStringCsv: string;
  refreshTimeOfDay: number;
  timezoneId: string;
}

export interface IUpdateDataFreshnessPolicyResult extends IResult {
}

export class UpdateDataFreshnessPolicyRequest
    extends Request<IUpdateDataFreshnessPolicyParams, IUpdateDataFreshnessPolicyResult> {
  constructor(params: IUpdateDataFreshnessPolicyParams) {
    super('updateWorkbookDataFreshnessPolicy', params);
  }
}
